// Production: the default *.emergent.host address redirects to the custom domain (path, query, hash kept).
export function canonicalRedirectUrl(loc, backendUrl) {
  if (!backendUrl || !loc.hostname.endsWith(".emergent.host")) return null;
  let canonical;
  try {
    canonical = new URL(backendUrl);
  } catch {
    return null;
  }
  if (canonical.protocol !== "https:" || canonical.hostname.endsWith(".emergent.host") || canonical.origin === loc.origin) return null;
  return `${canonical.origin}${loc.pathname}${loc.search}${loc.hash}`;
}
